import { Separator } from "@/frontend/components/ui/separator";
import { FormField } from "@/frontend/components/ui/form-field";
import { CopyField } from "@/frontend/components/ui/copy-field";
import type { FhirServerFormState } from "@/frontend/types/dashboard/settings/export";

export function InternalFhirView({ state }: { state: FhirServerFormState }) {
  return (
    <>
      <div className="px-6 pb-4 space-y-3">
        <FormField label="Destination Name" value={state.name} readOnly />
        <CopyField label="FHIR Base URL" value={state.fhirServerUrl} />
      </div>
      <Separator />
      <div className="px-6 py-4">
        <CopyField label="Bearer Token" value={state.bearerToken} />
      </div>
    </>
  );
}
